// import api from '@api';
import config from '@config';
import { call, put, takeEvery, take, all } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { initNotificationsConnection as initNotificationsConnectionAction } from './reducer';

import {
    getNotificationsActionsFetchSuccess,
    getNotificationsActionsFetchFailure,
    deleteNotificationsFetchSuccess,
    deleteNotificationsFetchFailure,
} from './reducer';
import { NotificationActionResType } from 'src/types/notification';
import api from '@api';

const getNotificationsActionsFetchRequest = async () => {
    const res = await api('get', 'api/secure/notifications/actions');
    return res.data.data;
};

function* getNotificationsActionsFetch(action: { type: string }) {
    try {
        const response: NotificationActionResType = yield call((): any => getNotificationsActionsFetchRequest());
        yield put(getNotificationsActionsFetchSuccess(response));
    } catch (error) {
        yield put(getNotificationsActionsFetchFailure({ error }));
    }
}

export function* getNotificationsActionsFetchWatch() {
    yield takeEvery('notifications/getNotificationsActionsFetch', getNotificationsActionsFetch);
}

let websocetHadOpen = false;
let myWebSocket: WebSocket;
let pingTimeout = -1;
let pingTimeoutFail = -1;

const websocketInitChannel: any = () => {
    return eventChannel((emitter: any): any => {
        const heartbeat: any = () => {
            clearTimeout(pingTimeout);
            clearTimeout(pingTimeoutFail);

            pingTimeout = window.setTimeout(() => {
                myWebSocket.send(
                    JSON.stringify({
                        action: 'onPing',
                    })
                );
                pingTimeoutFail = window.setTimeout(() => {
                    myWebSocket.close();
                }, 10000);
            }, 30000 + 1000);
        };

        if (!myWebSocket) {
            const token = localStorage.getItem('token');
            myWebSocket = new WebSocket(`${config.websocetURL}?token=${token}`);

            myWebSocket.onopen = (): any => {
                heartbeat();

                websocetHadOpen = true;

                return emitter({ type: 'notifications/openNotificationsConnection' });
            };

            myWebSocket.onmessage = (e: any): any => {
                heartbeat();
                const data = JSON.parse(e.data);
                switch (data.action) {
                    case 'onUnreadNotifications':
                        return emitter({
                            type: 'notifications/initAllPushNotifications',
                            payload: data.data,
                        });
                    case 'onNotification':
                        return emitter({
                            type: 'notifications/addPushNotification',
                            payload: data.data,
                        });
                    case 'onNotificationDeleted':
                        return emitter({
                            type: 'notifications/deletePushNotification',
                            payload: data.data,
                        });

                    default:
                        return null;
                }
            };

            myWebSocket.onclose = (): any => {
                if (websocetHadOpen) {
                    myWebSocket.close();
                    // myWebSocket = {};
                    // delete myWebSocket;
                    websocetHadOpen = false;
                    clearTimeout(pingTimeout);
                    clearTimeout(pingTimeoutFail);
                    return emitter({ type: 'notifications/closeNotificationsConnection' });
                }
            };
        }

        return () => {
            console.error('eventChannel return');
        };
    });
};

export function* initNotificationsConnection(): any {
    const channel = yield call(websocketInitChannel);
    while (true) {
        const action = yield take(channel);
        yield put(action);
    }
}

export function* initNotificationsConnectionWatch(): any {
    yield takeEvery('notifications/initNotificationsConnection', initNotificationsConnection);
}

export function* closeNotificationsConnection(): any {
    yield put(initNotificationsConnectionAction());
}

export function* closeNotificationsConnectionWatch(): any {
    yield takeEvery('notifications/closeNotificationsConnection', closeNotificationsConnection);
}

const deleteNotificationFetchRequest = async (_id: string) => {
    return myWebSocket.send(
        JSON.stringify({
            action: 'onPushNotificationDelete',
            _id,
        })
    );
};

function* deleteNotificationsFetch(action: { type: string; payload: string[] }) {
    try {
        yield all(action.payload.map((id) => call((): any => deleteNotificationFetchRequest(id))));
        yield put(deleteNotificationsFetchSuccess(action.payload));
    } catch (error) {
        yield put(deleteNotificationsFetchFailure(error));
    }
}

export function* deleteNotificationsFetchWatch() {
    yield takeEvery('notifications/deleteNotificationsFetch', deleteNotificationsFetch);
}
